import Image from 'next/image'
import s from './style.module.css'
import SearchCardImageShimmer from './shimmer'

type Props = {
  gameName: string
  gameCode: string
}

const SearchCardImage = ({gameName, gameCode}: Props) => {
  return (
    <div className={s.image_container}>
      <SearchCardImageShimmer />
      <Image src={`https://static.gamezop.com/${gameCode}/s/square.png`} alt={gameName} fill sizes='50px' />
    </div>
  )
}

export default SearchCardImage
